import { gql } from "@apollo/client";

export const CREATE_ORDER = gql`
  mutation CreateOrder($payload: CreateOrderPayload!) {
    createOrder(payload: $payload) {
      paymentIntent {
        clientSecret
        reference
      }
      productPrice
      paypal
      plaid
    }
  }
`;
